(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
  function initLibertasCollectionBanner(root) {
    const breadcrumb = root.querySelector('[data-collection-breadcrumb]')
    const header = document.querySelector('[data-header-menu][data-menu-source="assigned"]')
    if (!breadcrumb || !header) return

    const normalizePath = (value) => {
      try {
        const path = new URL(value, window.location.origin).pathname
        return decodeURIComponent(path).replace(/\/+$/, '') || '/'
      } catch {
        return ''
      }
    }

    const collectionPath = normalizePath(breadcrumb.dataset.collectionUrl)
    const matchingLinks = [...header.querySelectorAll('.lib-header__nav a[href]')]
      .filter((link) => normalizePath(link.href) === collectionPath)
      .sort((first, second) => {
        const depth = (link) => {
          if (link.closest('.lib-mega-menu__group li')) return 2
          if (link.matches('.lib-mega-menu__heading')) return 1
          return 0
        }
        return depth(second) - depth(first)
      })
    const currentLink = matchingLinks[0]
    if (!currentLink) return

    breadcrumb.querySelectorAll('[data-breadcrumb-menu-item]').forEach((item) => item.remove())
    const currentSeparator = breadcrumb.querySelector('[data-breadcrumb-current-separator]')
    const currentItem = breadcrumb.querySelector('[data-breadcrumb-current]')
    const parents = []
    const dropdown = currentLink.closest('.lib-menu__dropdown')
    const group = currentLink.closest('.lib-mega-menu__group')

    if (dropdown) {
      const summary = dropdown.querySelector(':scope > summary')
      const titleNode = summary?.querySelector('.lib-menu__desktop-title') || summary?.querySelector('span')
      const title = titleNode?.textContent.trim()
      const dropdownUrl = dropdown.dataset.menuUrl
      const hasDropdownUrl = dropdownUrl && dropdownUrl !== '#' && normalizePath(dropdownUrl) !== collectionPath
      if (title) parents.push({ title, url: hasDropdownUrl ? dropdownUrl : '' })
    }

    const groupHeading = group?.querySelector(':scope > .lib-mega-menu__heading')
    if (groupHeading && groupHeading !== currentLink && normalizePath(groupHeading.href) !== collectionPath) {
      parents.push({ title: groupHeading.textContent.trim(), url: groupHeading.href })
    }

    parents.forEach((parent) => {
      const separator = document.createElement('span')
      separator.dataset.breadcrumbMenuItem = ''
      separator.textContent = '/'

      const item = document.createElement(parent.url ? 'a' : 'span')
      item.dataset.breadcrumbMenuItem = ''
      item.textContent = parent.title
      if (parent.url) item.href = parent.url

      breadcrumb.insertBefore(separator, currentSeparator)
      breadcrumb.insertBefore(item, currentSeparator)
    })

    const menuTitle = currentLink.textContent.trim()
    if (menuTitle && currentItem) currentItem.textContent = menuTitle
  }

  document.querySelectorAll('[data-collection-banner]').forEach(initLibertasCollectionBanner)
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-collection-banner]').forEach(initLibertasCollectionBanner)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  function initLibertasCollectionFilters(root) {
    if (root.dataset.filtersReady === 'true') return
    root.dataset.filtersReady = 'true'

    const drawer = root.querySelector('[data-filter-panel]')
    const toggle = root.querySelector('[data-filter-toggle]')
    const closeButtons = root.querySelectorAll('[data-filter-close]')
    const quickSizeForm = root.querySelector('[data-size-filter-form]')
    const drawerForm = root.querySelector('[data-filter-form]')
    let lastFocusedElement = null

    const hasSelectedSize = (form) => [...form.querySelectorAll('[data-size-filter-input]')]
      .some((input) => input.checked)

    const syncQuickSizeAvailability = () => {
      if (!quickSizeForm) return
      const existingInput = quickSizeForm.querySelector('[data-auto-availability-input]')

      if (!hasSelectedSize(quickSizeForm)) {
        existingInput?.remove()
        return
      }

      if (existingInput || !quickSizeForm.dataset.availabilityParam) return
      const availabilityInput = document.createElement('input')
      availabilityInput.type = 'hidden'
      availabilityInput.name = quickSizeForm.dataset.availabilityParam
      availabilityInput.value = quickSizeForm.dataset.availabilityValue
      availabilityInput.dataset.autoAvailabilityInput = ''
      quickSizeForm.append(availabilityInput)
    }

    const syncDrawerAvailability = () => {
      if (!drawerForm) return
      const availableInput = drawerForm.querySelector('[data-availability-filter-input]')
      const unavailableInput = drawerForm.querySelector('[data-unavailable-filter-input]')
      if (!hasSelectedSize(drawerForm) || !availableInput) return
      availableInput.checked = true
      unavailableInput?.removeAttribute('checked')
      if (unavailableInput) unavailableInput.checked = false
    }

    quickSizeForm?.addEventListener('change', (event) => {
      if (!event.target.matches('[data-size-filter-input]')) return
      syncQuickSizeAvailability()
      quickSizeForm.requestSubmit()
    })

    drawerForm?.addEventListener('change', (event) => {
      if (!event.target.matches('[data-size-filter-input]')) return
      syncDrawerAvailability()
    })

    drawerForm?.addEventListener('submit', syncDrawerAvailability)

    if (quickSizeForm?.dataset.availabilityParam && hasSelectedSize(quickSizeForm)) {
      const currentAvailability = new URL(window.location.href).searchParams.getAll(quickSizeForm.dataset.availabilityParam)
      if (!currentAvailability.includes(quickSizeForm.dataset.availabilityValue) || currentAvailability.includes('0')) {
        syncQuickSizeAvailability()
        quickSizeForm.requestSubmit()
        return
      }
    }

    const openDrawer = () => {
      if (!drawer) return
      window.libertasPrepareScrollLock?.()
      lastFocusedElement = document.activeElement
      drawer.classList.add('is-open')
      drawer.setAttribute('aria-hidden', 'false')
      drawer.inert = false
      toggle?.setAttribute('aria-expanded', 'true')
      document.body.classList.add('lib-filter-drawer-open')
      requestAnimationFrame(() => drawer.querySelector('[data-filter-close]')?.focus())
    }

    const closeDrawer = () => {
      if (!drawer) return
      drawer.classList.remove('is-open')
      drawer.setAttribute('aria-hidden', 'true')
      drawer.inert = true
      toggle?.setAttribute('aria-expanded', 'false')
      document.body.classList.remove('lib-filter-drawer-open')
      lastFocusedElement?.focus?.()
    }

    toggle?.addEventListener('click', openDrawer)
    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer))
    drawer?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDrawer()
        return
      }
      if (event.key !== 'Tab') return
      const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary')]
        .filter((element) => element.getClientRects().length > 0)
      if (!focusable.length) return
      const first = focusable[0]
      const last = focusable[focusable.length - 1]
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    })
  }

  document.querySelectorAll('[data-collection-filters]').forEach(initLibertasCollectionFilters)
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-collection-filters]').forEach(initLibertasCollectionFilters)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  function initLibertasFooterLocalization(root) {
    if (root.dataset.footerLocalizationReady === 'true') return
    root.dataset.footerLocalizationReady = 'true'
    root.querySelectorAll('[data-footer-localization-select]').forEach((select) => {
      select.addEventListener('change', () => select.form?.requestSubmit())
    })
  }

  document.querySelectorAll('[data-footer-localization]').forEach(initLibertasFooterLocalization)
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-footer-localization]').forEach(initLibertasFooterLocalization)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initLibertasHeaderMenu(root) {
    if (root.dataset.menuReady === 'true') return
    root.dataset.menuReady = 'true'

    const mainMenu = root.querySelector('.lib-header__menu')
    const menuToggle = root.querySelector('.lib-header__menu-toggle')
    const dropdowns = [...root.querySelectorAll('.lib-menu__dropdown')]
    const mobileLocalizationSelects = [...root.querySelectorAll('[data-mobile-localization-select]')]
    const listenerController = new AbortController()
    let menuCloseTimer
    let lastScrollPosition = Math.max(window.scrollY, 0)
    let scrollTicking = false

    const revealHeader = () => root.classList.remove('is-hidden')
    const preloadDropdownImages = (dropdown) => {
      dropdown.querySelectorAll('.lib-mega-menu__collection-image[loading="lazy"]').forEach((image) => {
        image.loading = 'eager'
      })
    }
    const updateMenuViewportOffset = () => {
      root.style.setProperty('--lib-header-viewport-offset', `${Math.max(0, root.getBoundingClientRect().top)}px`)
    }

    const updateStickyHeader = () => {
      const currentScrollPosition = Math.max(window.scrollY, 0)
      const scrollDifference = currentScrollPosition - lastScrollPosition
      const hasOpenNavigation = root.classList.contains('is-search-open') || mainMenu?.classList.contains('is-open') || dropdowns.some((dropdown) => dropdown.open)
      const hasKeyboardFocus = root.contains(document.activeElement) && document.activeElement.matches(':focus-visible')
      const isInteracting = hasOpenNavigation || hasKeyboardFocus

      root.classList.toggle('is-scrolled', currentScrollPosition > 1)

      if (currentScrollPosition <= 16 || isInteracting || scrollDifference < -2) {
        revealHeader()
      } else if (scrollDifference > 3 && currentScrollPosition > root.offsetHeight) {
        root.classList.add('is-hidden')
      }

      lastScrollPosition = currentScrollPosition
      scrollTicking = false
    }

    const handleScroll = () => {
      if (scrollTicking) return
      scrollTicking = true
      requestAnimationFrame(updateStickyHeader)
    }

    const resetMobileDropdown = (dropdown, restoreFocus = false) => {
      const summary = dropdown.querySelector(':scope > summary')
      dropdown.classList.remove('is-mobile-open', 'is-closing')
      dropdown.removeAttribute('open')
      if (restoreFocus) summary?.focus()
    }

    const closeMobileDropdown = (dropdown, restoreFocus = true) => {
      if (!dropdown?.open) return
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      dropdown.classList.remove('is-mobile-open')
      dropdown.classList.add('is-closing')
      window.setTimeout(() => resetMobileDropdown(dropdown, restoreFocus), reducedMotion ? 0 : 290)
    }

    const openMobileDropdown = (dropdown) => {
      dropdowns.forEach((other) => {
        if (other !== dropdown) resetMobileDropdown(other)
      })
      preloadDropdownImages(dropdown)
      dropdown.classList.remove('is-closing')
      dropdown.setAttribute('open', '')
      requestAnimationFrame(() => {
        dropdown.classList.add('is-mobile-open')
        window.setTimeout(() => dropdown.querySelector('[data-mobile-menu-back]')?.focus(), 290)
      })
    }

    const closeMobileMenu = (restoreFocus = true) => {
      if (!mainMenu?.classList.contains('is-open')) return
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      window.clearTimeout(menuCloseTimer)
      mainMenu.classList.add('is-closing')
      mainMenu.classList.remove('is-open')
      menuToggle?.setAttribute('aria-expanded', 'false')
      dropdowns.forEach((dropdown) => resetMobileDropdown(dropdown))
      menuCloseTimer = window.setTimeout(() => mainMenu.classList.remove('is-closing'), reducedMotion ? 0 : 290)
      if (restoreFocus) menuToggle?.focus()
    }

    menuToggle?.addEventListener('click', () => {
      root.querySelector('libertas-quick-search')?.close({ restoreFocus: false })
      updateMenuViewportOffset()
      const isOpen = !mainMenu.classList.contains('is-open')
      if (isOpen) {
        window.libertasPrepareScrollLock?.()
        window.clearTimeout(menuCloseTimer)
        mainMenu.classList.remove('is-closing')
        mainMenu.classList.add('is-open')
      } else {
        closeMobileMenu(false)
      }
      menuToggle.setAttribute('aria-expanded', String(isOpen))
      revealHeader()
    })

    dropdowns.forEach((dropdown) => {
      const summary = dropdown.querySelector(':scope > summary')

      const openDesktopDropdown = () => {
        if (window.innerWidth < 990) return
        preloadDropdownImages(dropdown)
        dropdowns.forEach((other) => {
          if (other !== dropdown) other.removeAttribute('open')
        })
        dropdown.setAttribute('open', '')
        root.querySelector('libertas-quick-search')?.close({ restoreFocus: false })
        revealHeader()
      }

      dropdown.addEventListener('mouseenter', openDesktopDropdown)
      dropdown.addEventListener('mouseleave', () => {
        if (window.innerWidth >= 990) dropdown.removeAttribute('open')
      })
      dropdown.addEventListener('focusin', openDesktopDropdown)
      dropdown.addEventListener('focusout', (event) => {
        if (window.innerWidth < 990 || dropdown.contains(event.relatedTarget)) return
        dropdown.removeAttribute('open')
      })
      summary?.addEventListener('click', (event) => {
        if (window.innerWidth < 990) {
          event.preventDefault()
          openMobileDropdown(dropdown)
          return
        }
        if (!dropdown.dataset.menuUrl) return
        event.preventDefault()
        window.location.assign(dropdown.dataset.menuUrl)
      })
      dropdown.querySelector('[data-mobile-menu-back]')?.addEventListener('click', () => {
        closeMobileDropdown(dropdown)
      })

      dropdown.addEventListener('toggle', () => {
        if (dropdown.open) {
          root.querySelector('libertas-quick-search')?.close({ restoreFocus: false })
          revealHeader()
        }
        if (!dropdown.open || window.innerWidth < 990) return
        dropdowns.forEach((other) => {
          if (other !== dropdown) other.removeAttribute('open')
        })
      })
    })

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return
      if (window.innerWidth < 990) {
        const activeDropdown = dropdowns.find((dropdown) => dropdown.open)
        if (activeDropdown) {
          closeMobileDropdown(activeDropdown)
          return
        }
        closeMobileMenu()
        return
      }
      dropdowns.forEach((dropdown) => dropdown.removeAttribute('open'))
      mainMenu?.classList.remove('is-open')
      menuToggle?.setAttribute('aria-expanded', 'false')
      menuToggle?.focus()
    })

    document.addEventListener('click', (event) => {
      if (window.innerWidth < 990 || root.contains(event.target)) return
      dropdowns.forEach((dropdown) => dropdown.removeAttribute('open'))
    }, { signal: listenerController.signal })

    root.addEventListener('focusin', revealHeader)
    mobileLocalizationSelects.forEach((select) => {
      select.addEventListener('change', () => select.form?.requestSubmit())
    })
    window.addEventListener('scroll', handleScroll, { passive: true, signal: listenerController.signal })
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) {
        window.clearTimeout(menuCloseTimer)
        mainMenu?.classList.remove('is-open', 'is-closing')
        menuToggle?.setAttribute('aria-expanded', 'false')
        dropdowns.forEach((dropdown) => resetMobileDropdown(dropdown))
      } else if (mainMenu?.classList.contains('is-open')) {
        updateMenuViewportOffset()
      }
    }, { passive: true, signal: listenerController.signal })
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(root)) listenerController.abort()
    }, { signal: listenerController.signal })

    updateStickyHeader()
  }

  document.querySelectorAll('[data-header-menu]').forEach(initLibertasHeaderMenu)
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-header-menu]').forEach(initLibertasHeaderMenu)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-gallery"] && !Shopify.designMode) return;
  try {
    
  function initLibertasSocialCarousel(root) {
    if (root.dataset.socialReady === 'true') return
    root.dataset.socialReady = 'true'

    const viewport = root.querySelector('[data-social-track]')
    const previousButton = root.querySelector('[data-social-prev]')
    const nextButton = root.querySelector('[data-social-next]')
    const slides = [...root.querySelectorAll('.lib-social__slide')]

    const updateControls = () => {
      if (!viewport) return
      const maximum = viewport.scrollWidth - viewport.clientWidth
      if (previousButton) previousButton.disabled = viewport.scrollLeft <= 2
      if (nextButton) nextButton.disabled = viewport.scrollLeft >= maximum - 2
    }

    const move = (direction) => {
      if (!viewport || slides.length === 0) return
      const gap = parseFloat(getComputedStyle(root.querySelector('.lib-social__track')).gap) || 0
      viewport.scrollBy({ left: direction * (slides[0].getBoundingClientRect().width + gap), behavior: 'smooth' })
    }

    previousButton?.addEventListener('click', () => move(-1))
    nextButton?.addEventListener('click', () => move(1))
    viewport?.addEventListener('scroll', updateControls, { passive: true })

    root.querySelectorAll('[data-social-dialog]').forEach((dialog) => {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
      const closeDialog = () => {
        if (!dialog.open || dialog.classList.contains('is-closing')) return
        if (reducedMotion.matches) {
          dialog.close()
          return
        }
        dialog.classList.add('is-closing')
        window.setTimeout(() => {
          dialog.classList.remove('is-closing')
          if (dialog.open) dialog.close()
        }, 200)
      }
      dialog._libertasSocialClose = closeDialog
      dialog.querySelector('[data-social-close]')?.addEventListener('click', closeDialog)
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog()
      })
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault()
        closeDialog()
      })
      dialog.addEventListener('close', () => {
        dialog.classList.remove('is-closing')
        dialog._socialTrigger?.focus({ preventScroll: true })
      })

      const gallery = dialog.querySelector('[data-social-post-gallery]')
      const postMedia = [...dialog.querySelectorAll('[data-social-post-media]')]
      const mediaDots = [...dialog.querySelectorAll('[data-social-media-dot]')]
      const mediaStatus = dialog.querySelector('[data-social-media-status]')
      let activeMediaIndex = 0
      const showPostMedia = (requestedIndex) => {
        if (postMedia.length === 0) return
        activeMediaIndex = (requestedIndex + postMedia.length) % postMedia.length
        postMedia.forEach((media, index) => {
          const active = index === activeMediaIndex
          media.hidden = !active
          media.setAttribute('aria-hidden', String(!active))
        })
        mediaDots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === activeMediaIndex)))
        if (mediaStatus) mediaStatus.textContent = `Imagen ${activeMediaIndex + 1} de ${postMedia.length}`
      }
      dialog._libertasSocialResetMedia = () => showPostMedia(0)
      dialog.querySelector('[data-social-media-prev]')?.addEventListener('click', () => showPostMedia(activeMediaIndex - 1))
      dialog.querySelector('[data-social-media-next]')?.addEventListener('click', () => showPostMedia(activeMediaIndex + 1))
      mediaDots.forEach((dot) => {
        dot.addEventListener('click', () => showPostMedia(Number.parseInt(dot.dataset.socialMediaDot, 10)))
      })
      gallery?.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return
        event.preventDefault()
        if (event.key === 'ArrowLeft') showPostMedia(activeMediaIndex - 1)
        if (event.key === 'ArrowRight') showPostMedia(activeMediaIndex + 1)
        if (event.key === 'Home') showPostMedia(0)
        if (event.key === 'End') showPostMedia(postMedia.length - 1)
      })
      showPostMedia(0)

      const modalTitle = dialog.querySelector('[data-social-modal-title]')
      const productPickers = [...dialog.querySelectorAll('[data-social-product-picker]')]
      productPickers.forEach((picker) => {
        picker.addEventListener('toggle', () => {
          if (!picker.open) return
          productPickers.forEach((otherPicker) => {
            if (otherPicker !== picker) otherPicker.open = false
          })
          if (modalTitle) modalTitle.textContent = picker.dataset.productTitle
        })
      })

      dialog.querySelectorAll('[data-social-variant-select]').forEach((select) => {
        const form = select.closest('form')
        const addButton = form?.querySelector('[data-social-add]')
        const price = addButton?.querySelector('[data-social-add-price]')
        const updateVariant = () => {
          const selectedOption = select.selectedOptions[0]
          const unavailable = !select.value || selectedOption?.disabled
          if (addButton) {
            addButton.disabled = unavailable
            addButton.setAttribute('aria-disabled', String(unavailable))
          }
          if (price && selectedOption?.dataset.price) price.textContent = selectedOption.dataset.price
        }
        select.addEventListener('change', updateVariant)
        updateVariant()
      })
    })

    root.querySelectorAll('[data-social-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.socialOpen)
        if (!dialog || dialog.open) return
        dialog._socialTrigger = button
        dialog._libertasSocialResetMedia?.()
        if (typeof dialog.showModal === 'function') dialog.showModal()
        else dialog.setAttribute('open', '')
        window.requestAnimationFrame(() => {
          const firstFocus = dialog.querySelector('.lib-social-modal__user[href], [data-social-variant-select]:not(:disabled), [data-social-media-next], [data-social-close]')
          firstFocus?.focus({ preventScroll: true })
        })
      })
    })

    updateControls()
    if (viewport) {
      root._libertasSocialResizeObserver = new ResizeObserver(updateControls)
      root._libertasSocialResizeObserver.observe(viewport)
    }
  }

  document.querySelectorAll('[data-social-carousel]').forEach(initLibertasSocialCarousel)
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-social-carousel]').forEach(initLibertasSocialCarousel)
  })
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-social-carousel]').forEach((root) => root._libertasSocialResizeObserver?.disconnect())
  })
  if (!window.libertasSocialEditorListenerReady) {
    window.libertasSocialEditorListenerReady = true
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest?.('.lib-social__slide')
      slide?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
    })
  }
  if (!window.libertasSocialCartListenerReady) {
    window.libertasSocialCartListenerReady = true
    document.addEventListener('cart:updated', () => {
      document.querySelectorAll('[data-social-dialog][open]').forEach((dialog) => dialog._libertasSocialClose?.())
    })
  }

  } catch(e) { console.error(e); }
})();
})();
